import { eThanhPhanDiemActionTypeIds } from './../../action-types/so-diem/IThanhPhanDiemAction';
import { BaseAction } from "../IBaseActionResult";
import { sis_thanhphandiem } from '../../../models/response/so-diem/sis_thanhphandiem';

export const thanhPhanDiemActions = {
    loadStart: () => BaseAction(undefined, eThanhPhanDiemActionTypeIds.LOAD_START),
    loadSuccess: (respone: sis_thanhphandiem[]) => BaseAction(respone, eThanhPhanDiemActionTypeIds.LOAD_SUCCESS),
    loadError: (message: string) => BaseAction(message, eThanhPhanDiemActionTypeIds.LOAD_ERRROR)
}